const DAY_LABEL_TO_NUM: Record<string, number> = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
}

export const parseDeliveryDays = (raw: string | undefined): number[] => {
  if (!raw) return []
  const nums: number[] = []
  for (const label of raw.split(', ')) {
    const n = DAY_LABEL_TO_NUM[label]
    if (n !== undefined) nums.push(n)
  }
  return nums.sort((a, b) => a - b)
}

interface ILocationDeliveryDays {
  locationId: number
  deliveryDays?: string
}

// why: a delivery-day pattern alone matches the whole fleet, so the schedule's
// own store list is what bounds the count.
export const getComboStoreIds = (
  locations: ILocationDeliveryDays[],
  scheduleStoreIds: number[] | undefined,
  comboDeliveryDays: number[] | undefined,
): number[] => {
  const inSchedule = new Set(scheduleStoreIds || [])
  const wanted = [...(comboDeliveryDays || [])].sort((a, b) => a - b).join(',')

  return locations
    .filter((l) => {
      if (!inSchedule.has(l.locationId)) return false
      return parseDeliveryDays(l.deliveryDays).join(',') === wanted
    })
    .map((l) => l.locationId)
}
